import React from 'react'
import TimelineLink from './timeline-link.component'
import { CurecallTag, ECurecallSize } from '@honestica/curecall-ui'

type TimelineSkeletonProps = {
  itemsCount?: number
  medEventPosition?: number
}

export default function TimelineSkeleton({ itemsCount = 4, medEventPosition = 2 }: TimelineSkeletonProps) {
  return Array.from({ length: itemsCount }, (_, i) => i + 1).map((itemNumber) => (
    <React.Fragment key={`timeline-skeleton-${itemNumber}`}>
      <TimelineLink done={true} />
      {itemNumber === medEventPosition ? (
        <div className="medevent medevent--muted c-animate-pulse">
          <div className="c-flex c-flex-col c-items-center c-flex-1">
            <h6 className="c-mb-1">
              <div className="c-h-5 c-w-[140px] c-bg-gray-300 c-rounded" />
            </h6>
            <div className="c-h-4 c-w-[100px] c-bg-gray-200 c-rounded" />
          </div>
        </div>
      ) : (
        <div className="workflow">
          <div className="workflow__date c-w-max workflow__date--muted">
            <div className="c-h-4 c-w-[120px] c-bg-gray-300 c-rounded c-animate-pulse" />
          </div>
          <div className="workflow__rounded workflow__rounded--muted" />
          <CurecallTag
            className="c-absolute c-left-[40px]"
            size={ECurecallSize.SMALL}
            isWorkflow
            isDisabled={true}
          >
            <div className="c-h-4 c-w-[160px] c-bg-gray-300 c-rounded" />
          </CurecallTag>
        </div>
      )}
      <TimelineLink done={true} />
    </React.Fragment>
  ))
}
